import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';
import {IContent} from '../../administration/contents/contents';

@Injectable()
export class ArticleService {
    constructor(
        private _http: HttpClient,
    ) {
    }

    fetchAll(): Observable<IContent[]> {
        return <any>this._http.get(`${environment.api}/articles`);
    }

    fetch(articleId: number): Observable<IContent> {
        return <any>this._http.get(`${environment.api}/articles/${articleId}`);

    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/services/article.service.ts